module.exports = __webpack_public_path__ + "img/car_6.1cf5b246.jpeg";